import ErrorBoundary from "../components/ErrorBoundary.jsx";
import { useProductMe } from "../hooks/useProductMe.js";
import Login from "./Login.jsx";
import ProjectDashboard from "./ProjectDashboard.jsx";

export default function HomeEntry() {
  const { me, loading, refresh } = useProductMe();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "var(--bg-base)",
          color: "var(--text-secondary)",
        }}
      >
        Loading…
      </div>
    );
  }

  if (!me?.authenticated) {
    return <Login onLoginSuccess={refresh} />;
  }

  return (
    <ErrorBoundary>
      <ProjectDashboard userEmail={me?.user?.email} />
    </ErrorBoundary>
  );
}
